module.exports = __webpack_public_path__ + "img/store-restapi.cce405a7.svg";